import { render, staticRenderFns } from "./ButtonWithLoadWebsite.vue?vue&type=template&id=8d6bca10&scoped=true&"
import script from "./ButtonWithLoadWebsite.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoadWebsite.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithLoadWebsite.vue?vue&type=style&index=0&id=8d6bca10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6bca10",
  null
  
)

export default component.exports